import { CommonModule } from '@angular/common';
import { Component, Input, HostListener, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'ngb-modal-content',
    templateUrl: './ngb-modal-content.component.html',
    styleUrls: ['./ngb-modal-content.component.scss'],
    standalone: false
})
export class NgbdModalContentComponent {
        @Input()
    public title: string;

    @Input()
    public text: string;

    @Input()
    public handlers: NgbModalHandlers[];

    @Output()
    public close = new EventEmitter();

    @HostListener('document:keydown.escape', ['$event'])
    public onEscapePressed(event: any) {
            event.stopPropagation();

        const defaults = this.handlers.filter(x => x.isDefault === true);
        if (defaults.length === 1) {
                this.close.emit(defaults[0].value);            
        }
    }

    constructor() {
        }

    public submit(value: any) {
            this.close.emit(value);        
    }
}

class NgbModalHandlers {
    public displayName: string;
    public value: any;
    public style?: string;
    public isDefault: boolean;
}